import { useHydrated } from 'remix-utils';
import {
    MagicIsland,
    MagicIslandProvider,
} from '~/ui-rocco/pages/detail-shared/magic-island';
import { HomePageScopeContext, useHomePageRevamp } from './use-is-home-page';

/**
 * Wraps a homepage: marks its sections as the revamped homepage's, and hosts
 * the Magic Island its carousels hand their pagination to. The island is
 * desktop only; phones keep each carousel's own pagination. With `revamp_2026`
 * off it marks nothing and hosts no island.
 */
export const HomePageScope = ({ children }: { children: React.ReactNode }) => {
    const hydrated = useHydrated();
    const revamp = useHomePageRevamp();
    if (!revamp) return <>{children}</>;
    return (
        <HomePageScopeContext.Provider value={true}>
            <MagicIslandProvider>
                {children}
                {hydrated ? (
                    <div className="max-md:hidden">
                        <MagicIsland />
                    </div>
                ) : null}
            </MagicIslandProvider>
        </HomePageScopeContext.Provider>
    );
};
